/* import __COLOCATED_TEMPLATE__ from './popover-menu-item-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type FieldInformationTooltip } from 'embercom/objects/standalone/data-fields/common';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export interface PopoverMenuItemTooltipArgs {
  tooltipAttrs: {
    item: FieldInformationTooltip;
  };
}

type categoryKeys = 'conversation' | 'people' | 'company';

const CATEGORY_MAP = {
  ['conversation']: {
    label: 'conversation-category',
    icon: 'conversation',
  },
  ['people']: {
    label: 'people-category',
    icon: 'person',
  },
  ['company']: {
    label: 'company-category',
    icon: 'company',
  },
};

export default class PopoverMenuItemTooltip extends Component<PopoverMenuItemTooltipArgs> {
  get item() {
    return this.args.tooltipAttrs.item;
  }

  get categoryIcon() {
    return (CATEGORY_MAP[this.item.category as categoryKeys].icon ||
      'conversation') as InterfaceIconName;
  }

  get categoryLabel() {
    return CATEGORY_MAP[this.item.category as categoryKeys].label;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::PopoverMenu::Standalone::PopoverMenuItemTooltip': typeof PopoverMenuItemTooltip;
    'workflows/graph-editor/popover-menu/standalone/popover-menu-item-tooltip': typeof PopoverMenuItemTooltip;
  }
}
